/* ============================================================
   GOOTER - OpenAI Ads (ChatGPT-Anzeigen) Kaufmessung
   Additiv, beruehrt keine bestehenden Trackings.

   1. Klick aus einer ChatGPT-Anzeige bringt ?oppref=... mit.
   2. Nur mit Marketing-Einwilligung (gooter_consent_v1.marketing):
      - Kennung 30 Tage in localStorage `gooter_oai_oppref_v1` merken
      - als versteckte Warenkorb-Eigenschaft `_oai_oppref` setzen
        (landet in der Bestellung; der taegliche GOOTER-Bericht meldet
        solche Kaeufe serverseitig an die OpenAI Conversions API,
        Werkzeug: my-pergola24-wp/tools/openai_ads_kaeufe.py)
      - OpenAI Measurement Pixel laden (Produkt angesehen, Warenkorb, Kasse begonnen)
   Ohne Einwilligung wird nichts gespeichert und nichts geladen.
   ============================================================ */
(function () {
  'use strict';

  var PIXEL_ID = 'SqRU9bpaFN7GFcCXUmLiVu';
  var KEY = 'gooter_oai_oppref_v1';
  var ATTR = '_oai_oppref';
  var TTL = 30 * 24 * 60 * 60 * 1000;
  var pendingRef = '';

  function marketingOk() {
    try {
      var c = JSON.parse(localStorage.getItem('gooter_consent_v1') || 'null');
      return !!(c && c.c && c.c.marketing);
    } catch (e) { return false; }
  }

  function refFromUrl() {
    var m = window.location.search.match(/[?&]oppref=([^&#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function stored() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (s && s.v && Date.now() - s.ts < TTL) return s.v;
    } catch (e) {}
    return '';
  }

  function syncCart(ref) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.attributes && cart.attributes[ATTR] === ref) return;
        var attrs = {}; attrs[ATTR] = ref;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () {});
  }

  function loadPixel() {
    if (window.oaiq) return;
    (function (w, d, s, u) {
      if (w.oaiq) return;
      var q = function () { q.q.push(arguments); };
      q.q = [];
      w.oaiq = q;
      var js = d.createElement(s);
      js.async = true;
      js.src = u;
      var f = d.getElementsByTagName(s)[0];
      f.parentNode.insertBefore(js, f);
    })(window, document, 'script', 'https://bzrcdn.openai.com/sdk/oaiq.min.js');
    window.oaiq('init', { pixelId: PIXEL_ID });
  }

  function activate() {
    if (!marketingOk()) return;
    var ref = pendingRef || stored();
    if (pendingRef) {
      try { localStorage.setItem(KEY, JSON.stringify({ v: pendingRef, ts: Date.now() })); } catch (e) {}
    }
    if (!ref) return;
    loadPixel();
    syncCart(ref);
    // Produktseite angesehen: je Seitenaufruf genau einmal
    if (window.gooterItem && !window.__gooterOaiViewed) {
      window.__gooterOaiViewed = true;
      window.oaiq('measure', 'contents_viewed', { type: 'contents', amount: cents(window.gooterItem.price), currency: (window.gooterCtx || {}).currency || 'EUR' });
    }
  }

  // gooterItem/gooterCart liefern z. B. "2.599", "2.599.00" oder "899.00" (Punkt als Tausender- UND Dezimaltrenner)
  // -> nur ein zweistelliger letzter Teil gilt als Cent, alles andere als Tausendergruppen
  function cents(v) {
    var p = String(v || '0').replace(/[^\d.]/g, '').split('.');
    var dec = (p.length > 1 && p[p.length - 1].length === 2) ? p.pop() : '00';
    var whole = parseInt(p.join('') || '0', 10);
    return whole * 100 + parseInt(dec, 10);
  }

  document.addEventListener('click', function (e) {
    if (!window.oaiq || !marketingOk() || !stored()) return;
    var cur = (window.gooterCtx || {}).currency || 'EUR';
    if (e.target.closest('[name="add"], .product-form__submit, [data-gooter-upsell-add]')) {
      var it = window.gooterItem || {};
      window.oaiq('measure', 'items_added', { type: 'contents', amount: cents(it.price), currency: cur });
      return;
    }
    if (e.target.closest('[name="checkout"], #checkout, .cart__checkout-button')) {
      var cart = window.gooterCart || {};
      window.oaiq('measure', 'checkout_started', { type: 'contents', amount: cents(cart.total_price), currency: cart.currency || cur });
    }
  }, true);

  function boot() {
    pendingRef = refFromUrl();
    activate();
    if (window.GooterConsentGate && !marketingOk() && (pendingRef || stored())) {
      window.GooterConsentGate.register('marketing', activate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
